import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { catchError, Observable } from "rxjs";
import { USER_URL } from "../shared/src";
import { ErrorHandlerService } from "./error-handler.service";

@Injectable({
    providedIn: 'root',
})

export class UserLeaveService {
    private readonly USER_LEAVE_API = `${USER_URL}`;
    constructor(
        private http: HttpClient,
        private errorHandler: ErrorHandlerService
    ) { }

    public requestedLeaveGetAll(params: {
        pageIndex?: number,
        pageSize?: number,
        searchFilter?: string,
        country?: string | number | null,
        name?: string,
        requestStatus?: string,
        userType?: string,
        fromDate?: string | Date | null,
        toDate?: string | Date | null,
        leaveTypeId?: number,
    }
    ): Observable<any> {
        let queryParams = new HttpParams()

        if (params.pageIndex) {
            queryParams = queryParams.set('pageIndex', params.pageIndex);
        }
        if (params.pageSize) {
            queryParams = queryParams.set('pageSize', params.pageSize);
        }
        if (params.searchFilter) {
            queryParams = queryParams.set('searchFilter', params.searchFilter);
        }
        if (params.country) {
            queryParams = queryParams.set('country', String(params.country));
        }
        if (params.name) {
            queryParams = queryParams.set('name', params.name);
        }
        if (params.requestStatus) {
            queryParams = queryParams.set('requestStatus', params.requestStatus);
        }
        if (params.userType) {
            queryParams = queryParams.set('userType', params.userType);
        }
        if (params.fromDate) {
            const fromDateString = new Date(params.fromDate as any).toLocaleDateString('en-CA');
            queryParams = queryParams.set('fromDate', fromDateString);
        }
        if (params.toDate) {
            const toDateString = new Date(params.toDate as any).toLocaleDateString('en-CA');
            queryParams = queryParams.set('toDate', toDateString);
        }
        if (params.leaveTypeId) {
            queryParams = queryParams.set('leaveTypeId', params.leaveTypeId);
        }
        return this.http
            .get<any>(
                `${this.USER_LEAVE_API}/ApplyLeave/getRequestedLeaves`, { params: queryParams }
            )
            .pipe(catchError(this.errorHandler.handleError));
    }

    public approveLeave(params: { id: number, comments: string, status: string }): Observable<any> {
        return this.http
            .put<any>(`${this.USER_LEAVE_API}/ApplyLeave/approveLeave`, params)
            .pipe(catchError(this.errorHandler.handleError));
    }

    public approveLeaveBulk(params: {
        ids: number[];
        comments: string;
        status: string;
    }): Observable<{ approved: number[]; failed: { id: number; reason: string }[] }> {
        return this.http
            .put<{ approved: number[]; failed: { id: number; reason: string }[] }>(
                `${this.USER_LEAVE_API}/ApplyLeave/approveLeaveBulk`,
                params
            )
            .pipe(catchError(this.errorHandler.handleError));
    }

    public filterData(country?: number | string | null): Observable<any> {
        let queryParams = new HttpParams();
        if (country) {
            queryParams = queryParams.set('country', String(country));
        }
        return this.http
            .get<any>(`${this.USER_LEAVE_API}/ApplyLeave/getDataForFilterings`, { params: queryParams })
            .pipe(catchError(this.errorHandler.handleError));
    }

    exportLeaveRequests(filters?: {
        pageIndex?: number,
        pageSize?: number,
        searchFilter?: string,
        country?: string | number | null,
        name?: string,
        requestStatus?: string,
        userType?: string,
        fromDate?: string | Date | null,
        toDate?: string | Date | null,
        leaveTypeId?: number | null,
    }): Observable<Blob> {
        const payload = {
            columns: [
                'Name',
                'Request Date',
                'Start Date',
                'End Date',
                'Approver',
                'Approved Date',
                'Days',
                'User Type',
                'Approval Status',
                'Reason',
                'Leave Type',
                'Available Leaves',
                'Taken Leaves',
                'Comments',
                'Day Type',
                'Attachment Name'
            ],
            ...filters
        };

        return this.http.post<Blob>(
            `${this.USER_LEAVE_API}/ApplyLeave/downloadExcelReport`,
            payload,
            { responseType: 'blob' as 'json' }
        );
    }
}